import { useQuery } from 'react-query';
import type { UseQueryResult } from 'react-query';
// FIXME: this will be removed in https://hotjar.atlassian.net/browse/MP-2773
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { useFeatureFlag } from '@hotjar/feature-flags';
import { getProductCatalog } from '../api/get-product-catalog';
import type { BillingPeriod, Currency, ProductCatalog } from '../api/model';
import { PRODUCT_CATALOG_QUERY_CONFIG, PRODUCT_CATALOG_QUERY_KEY } from './config';

interface Props {
  billingPeriod: BillingPeriod;
  currency: Currency;
  enabled?: boolean;
}

export const useProductCatalog = ({
  billingPeriod,
  currency,
  enabled = true,
}: Props): UseQueryResult<ProductCatalog> => {
  const isV2Catalog = useFeatureFlag('billing_new_scale');

  return useQuery(
    [PRODUCT_CATALOG_QUERY_KEY, billingPeriod, currency],
    () => getProductCatalog(billingPeriod, currency, isV2Catalog ? 'v2' : 'v1'),
    {
      ...PRODUCT_CATALOG_QUERY_CONFIG,
      enabled,
    },
  );
};
